import { baseAPI } from 'services/baseApi';

export const loginHistoryApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    loginHistory: builder.query({
      query: (params) => ({
        url: '/login-history',
        method: 'GET',
        params: {
          'user-id': params?.id,
          limit: params?.limit,
          offset: params?.offset,
          ipAddress: params?.ipAddress,
          token: params?.token,
          status: params?.status,
          loginDate: params?.loginDate,
          logoutDate: params?.logoutDate,
          createdAt: params?.createdAt
        }
      }),
      providesTags: ['LOGIN_HISTORY_LIST'],
      invalidatesTags: ['LOGIN_HISTORY_LIST']
    }),

    logoutUser: builder.mutation({
      query: ({ token }) => ({
        url: '/auth/logout',
        method: 'POST',
        body: { token }
      }),
      invalidatesTags: ['LOGIN_HISTORY_LIST']
    })
  })
});

export const { useLoginHistoryQuery, useLogoutUserMutation } = loginHistoryApi;
